import { render } from "./FooterProactive.vue?vue&type=template&id=76fd7351&scoped=true"
import script from "./FooterProactive.vue?vue&type=script&lang=js"
export * from "./FooterProactive.vue?vue&type=script&lang=js"

import "./FooterProactive.vue?vue&type=style&index=0&id=76fd7351&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76fd7351"]])

export default __exports__